<template>
    <rkm-modal
        extra-large
        ref="Modal"
        title="Detalhes"
    >
        <rkm-table
            :fields="fields"
            :items="atendimento.itens"
            :tbody-tr-class="rowClass"
            class="table-atendimento"
            foot-clone
            hide-filters
            hide-pagination
            no-footer-sorting
        >
            <template #thead-top>
                <rkm-tr>
                    <rkm-th :colspan="fields.length">
                        <h6><strong>{{ atendimento.pacienteNome }}</strong></h6>

                        <div class="atendimento-info">
                            <span v-if="atendimento.pacienteProntuario">
                                <strong>Prontuário</strong> {{ atendimento.pacienteProntuario }}
                            </span>
                            <span><strong>FAA</strong> {{ atendimento.faaNumero }}</span>
                            <span><strong>Data</strong> {{ formatDate(atendimento.dataAberturaFaa) }}</span>
                            <span v-if="atendimento.classificacaoRiscoNome">
                                <strong>Classificação de risco</strong> {{ atendimento.classificacaoRiscoNome }}
                            </span>
                            <span v-if="atendimento.cids.length > 0">
                                <strong>CID(s)</strong> {{ atendimento.cids.join(' | ') }}
                            </span>
                            <span><strong>Tempo total</strong> {{ atendimento.tempoTotal }}</span>
                        </div>
                    </rkm-th>
                </rkm-tr>
            </template>

            <template v-slot:cell(setorNome)="{ item, value }">
                <span v-if="item.evadido"><rkm-icon icon="exclamation-triangle" /> Evasão - {{ value }}</span>
                <span v-else-if="item.cancelamentoEvasao"><rkm-icon icon="reply" /> Cancelamento de evasão - {{ value }}</span>
                <span v-else-if="item.reaberto"><rkm-icon icon="reply" /> Reaberto</span>
                <span v-else>{{ value }}</span>
            </template>

            <template v-slot:cell(usuario)="{ item }">
                {{ item.usuarioNome }} - {{ item.ocupacaoCodigo }}
            </template>

            <template #foot(setorNome)>
                <span></span>
            </template>

            <template #foot(usuario)>
                <span></span>
            </template>

            <template #foot(data)>
                <span></span>
            </template>

            <template #foot(horarioChegada)>
                <span></span>
            </template>

            <template #foot(horarioInicio)>
                <span></span>
            </template>

            <template #foot(horarioConclusao)>
                <span></span>
            </template>

            <template #foot(tempoEspera)>
                <span>{{ atendimento.tempoTotalEspera }}</span>
            </template>

            <template #foot(tempoAtendimento)>
                <span>{{ atendimento.tempoTotalAtendimento }}</span>
            </template>
        </rkm-table>

        <template v-slot:footer="{ cancel }">
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
            >
                Fechar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="print"
                color="primary"
            >
                Imprimir
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import { repository, error, stringCase, file, formats } from '@/mixins'

// Vuex.
import { mapGetters, mapActions } from 'vuex'

export default {
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        fields() {
            return [
                { key: 'setorNome', label: 'Setor' },
                { key: 'usuario', label: 'Profissional - CBO' },
                { key: 'data', label: 'Data', class: 'col-min text-center' },
                { key: 'horarioChegada', label: 'Chegada', class: 'col-min text-center', formatter: v => v === null ? '-' : v },
                { key: 'horarioInicio', label: 'Início', class: 'col-min text-center', formatter: v => v === null ? '-' : v },
                { key: 'horarioConclusao', label: 'Conclusão', class: 'col-min text-center', formatter: v => v === null ? '-' : v },
                { key: 'tempoEspera', label: 'Espera', class: 'col-min text-center', formatter: v => v === null ? '-' : v },
                { key: 'tempoAtendimento', label: 'Atendimento', class: 'col-min text-center', formatter: v => v === null ? '-' : v },
            ]
        }
    },
    created() {
        this.repositories = {
            impressao: this.getConectaSusRepository('impressao.prontoAtendimento'),
        }
    },
    data: () => ({
        filtros: null,
        atendimento: [],
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(filtros, atendimento) {
            this.filtros = filtros
            this.atendimento = atendimento

            this.$refs.Modal.show()
        },
        print() {
            this.setLoading()

            this.repositories.impressao.relatorioTempoAtendimentoFila(this.prepareData())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        prepareData() {
            const params = {
                ...this.filtros,
                atendimento_id: this.atendimento.atendimentoId,
            }

            params.columns = this.fields.map(f => ({
                key: this.camelToSnake(f.key),
                label: f.label,
                class: f.class
            }))

            return params
        },
        rowClass(item, type) {
            if (type === 'row' && item) {
                if (item.evadido) {
                    return 'table-danger'
                }
            }
        }
    },
    mixins: [repository, error, stringCase, file, formats],
}
</script>

<style scoped>
.table-atendimento >>> .atendimento-info > span:not(:last-of-type) {
    margin-right: 10px;
}
</style>